import { Badge } from 'react-bootstrap';
import { Color } from 'react-bootstrap/esm/types';

export enum BadgeStatus {
  Info = "info",
  Success = "success",
  Warning = "warning",
  Danger = "danger"
}

export const StatusBadge = ({ badgeStatus, statusText }: IStatus) => {
  const badgeStr = badgeStatus.toString();
  const statusColor: Color = isColor(badgeStr) ? badgeStr : 'info';

	return (
    <Badge pill bg={statusColor} text={statusColor}>
      {statusText}
		</Badge>
	);
};

const isColor = (value: string): value is Color =>
  validColors.includes(value as Color);

export interface IStatus {
  badgeStatus: BadgeStatus;
  statusText: string
}

const validColors: Color[] = [
  'primary',
  'secondary',
  'success',
  'danger',
  'warning',
  'info',
];
